import { AxiosResponse } from "axios";

import { api } from "@/lib/api-client.ts";

import { Email } from "@/models/base/email.ts";
import { EmailDto } from "@/models/internal/email-dto.ts";

import { ServiceURL } from "@/utils/apiUtils.ts";

export const addEmail = async (emailDto: EmailDto): Promise<Email | undefined> => {
    try {
        const response: AxiosResponse<Email> = await api.post(ServiceURL.EMAILS.BASE, emailDto);

        const email: Email = response.data;

        return email;
    } catch (error) {
        console.warn(error);
        return undefined;
    }
};
